const COMMON_CIDS = [
    { code: '6A00', description: 'Transtorno do Espectro do Autismo' },
    {
        code: '6A02',
        description: 'Transtorno de Déficit de Atenção e Hiperatividade',
    },
    { code: '6A70', description: 'Transtorno Depressivo Episódio Único' },
    { code: '6A71', description: 'Transtorno Depressivo Recorrente' },
    { code: '6B00', description: 'Transtorno de Ansiedade Generalizada' },
    { code: '6B01', description: 'Transtorno do Pânico' },
];

export const getCidLabel = (code: string): string => {
    const match = COMMON_CIDS.find((cid) => cid.code === code);
    return match ? `${match.code} - ${match.description}` : code;
};
